import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[(_vm.auth)?_c('NavBarLogued'):_vm._e(),(!_vm.auth)?_c('NavBarLogout'):_vm._e(),(_vm.loading.state)?_c('Loader'):_vm._e(),_c(VMain,{staticStyle:{"margin-left":"64px","margin-top":"50px"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }